import React from "react";
import { Helmet } from "react-helmet";

import BannerSlider from "../Components/BannerSlider";
import WelcomeSection from "../Components/WelcomeSection";
import ContactSection from "../Components/ContactSection";
import FullWidthImageSection from "../Components/FullWidthImageSection";
import HomeProductsSlider from "../Components/HomeProductsSlider";
import VangalHeroSection from "../Components/VangalHeroSection";
import ApproachSection from "../Components/ApproachSection";
import CenterIllustration from "../Components/CenterIllustration";
import VangalProductSlider from "../Components/VangalProductSlider";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Vangal Farms | Fresh Dairy Products for Every Home</title>
        <meta
          name="description"
          content="Welcome to Vangal Farms—your trusted source for pure, fresh, and high-quality dairy products. Explore our range of ghee, butter, paneer, curd, and more, crafted with care from farm to home."
        />
      </Helmet>

      <BannerSlider />
      <WelcomeSection />
      <ContactSection />
      <FullWidthImageSection />
      <HomeProductsSlider />
      <VangalHeroSection />
      <ApproachSection />
      <CenterIllustration />
      <VangalProductSlider />
    </>
  );
}
